import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _isNumber from 'lodash/isNumber';
import _isString from 'lodash/isString';
import _isFinite from 'lodash/isFinite';
import _size from 'lodash/size';
import _head from 'lodash/head';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
export const tget = (object, path, defaultValue) => {
  const result = _get(object, path, defaultValue);
  return _isNil(result) ? defaultValue : result;
};
const DISPLAY_SIZES = {
  // in px (absolute viewport size)
  M: 1440,
  S: 1280,
  XS: 834
};
let DISPLAY_SCALES = {
  // in % (percentage font-size)
  MAXIMUM: 100.0,
  L: 57.5,
  M: 52.5,
  S: 47.5,
  XS: 42.5,
  MINIMUM: 10.0
};
const SCALE_TYPES = {
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL'
};
let DEFAULT_DISPLAY_SCALE = DISPLAY_SCALES.L;
const DEFAULT_SCALE_TYPE = SCALE_TYPES.AUTOMATIC;
const PROBE_DIV_ELEMENT_HEIGHT = 64; // in px (defined 6.4rem in index.html)
const PROBE_DIV_ELEMENT_ID = 'probe-div-element';
const isPxSizeString = sizeString => /^\d+(\.\d+)?(px)?$/.test(sizeString);
const domScaleTypeKey = 'data-scale-type';
export const setDisplayScales = displayScales => {
  DISPLAY_SCALES = _objectSpread({
    MAXIMUM: 100.0,
    L: 57.5,
    M: 52.5,
    S: 47.5,
    XS: 42.5,
    MINIMUM: 10.0
  }, displayScales);
  DEFAULT_DISPLAY_SCALE = DISPLAY_SCALES.L;
};
export const getFontSizeFromDOM = () => {
  const {
    fontSize
  } = document.querySelector('html').style;
  const matches = (fontSize || '').match(/(\d){1,3}(\.\d+)?%/g);
  if (_size(matches) !== 1) return DEFAULT_DISPLAY_SCALE;
  const numericScale = parseFloat(_head(matches));
  if (_isFinite(numericScale)) return numericScale;
  return DEFAULT_DISPLAY_SCALE;
};
export const getScaleTypeFromDOM = () => {
  const htmlDomEl = document.querySelector('html');
  return tget(htmlDomEl, domScaleTypeKey, DEFAULT_SCALE_TYPE);
};
export const setFontSizeInDOM = fontSize => {
  const fontSizeToSet = _isNumber(fontSize) ? fontSize : DEFAULT_DISPLAY_SCALE;
  document.querySelector('html').style.fontSize = "max(".concat(fontSizeToSet, "%)");
};
export const setScaleTypeInDOM = scaleType => {
  document.querySelector('html')[domScaleTypeKey] = SCALE_TYPES[scaleType] || DEFAULT_SCALE_TYPE;
};
export const getProbeDivElement = () => document.querySelector("#".concat(PROBE_DIV_ELEMENT_ID));
export const getSizeErrorCorrectionFactor = displayScale => {
  const calculatedSize = getScaleAdjustedSize(PROBE_DIV_ELEMENT_HEIGHT, {
    isErrorCorrectionEnabled: false,
    currentDisplayScale: displayScale || DEFAULT_DISPLAY_SCALE
  });
  /* Sample height from probe div element in dom and
   * calculate errorCorrectionFactor
   */
  const probeDivEl = getProbeDivElement();
  if (!probeDivEl) return 0;
  const {
    height: domSizeString
  } = getComputedStyle(probeDivEl);
  const domSize = parseFloat(domSizeString.replace('%', ''));
  /* [Fraction of change] errorCorrectionFactor = (domSize - definedSize) / domSize
   * errorCorrectionFactor > 0 => domSize is larger => increase calculated size
   * errorCorrectionFactor < 0 => domSize is smaller => decrease calculated size
   */
  return 1 - calculatedSize / domSize;
};
export const getScaleAdjustedSize = function () {
  let sizeInPx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '0';
  let extraArgs = arguments.length > 1 ? arguments[1] : undefined;
  const {
    currentDisplayScale,
    defaultDisplayScale,
    errorCorrectionFactor,
    isErrorCorrectionEnabled
  } = Object.assign({
    currentDisplayScale: getFontSizeFromDOM(),
    defaultDisplayScale: DEFAULT_DISPLAY_SCALE,
    errorCorrectionFactor: window.pxToRemErrorRate || 0,
    isErrorCorrectionEnabled: true
  }, extraArgs);
  const sizeToAdjust = _isString(sizeInPx) && isPxSizeString(sizeInPx) ? parseFloat(sizeInPx) : sizeInPx;
  if (!_isNumber(sizeToAdjust)) return sizeInPx;
  const pxScalingFactor = currentDisplayScale / defaultDisplayScale;
  const scaleAdjustedSize = sizeToAdjust * pxScalingFactor;
  if (!isErrorCorrectionEnabled) return scaleAdjustedSize;
  // error-corrected, scale-adjusted size in px
  return scaleAdjustedSize * (1 + errorCorrectionFactor);
};
export const setDisplayScaleAutomatically = width => {
  if (getScaleTypeFromDOM() !== SCALE_TYPES.AUTOMATIC) return;
  let scaleTypeToSet = DEFAULT_DISPLAY_SCALE;
  if (width <= DISPLAY_SIZES.XS) scaleTypeToSet = DISPLAY_SCALES.XS;else if (width <= DISPLAY_SIZES.S) scaleTypeToSet = DISPLAY_SCALES.S;else if (width <= DISPLAY_SIZES.M) scaleTypeToSet = DISPLAY_SCALES.M;
  setFontSizeInDOM(scaleTypeToSet);
};